import { useSideMenu } from "@shared/contexts/SideMenuContext";
import { useCallback, useEffect, useState } from "react";

/**
 * AccountDialogの開閉状態と位置（top）を管理するカスタムフック
 */
export const useAccountDialogPosition = () => {
  const { isOpenSideMenu } = useSideMenu();
  const [isAccountDialogOpen, setAccountDialogOpen] = useState(false);
  const [dialogTop, setDialogTop] = useState<string>("calc(100vh - 445px)");
  const [dialogLeft, setDialogLeft] = useState<string>(
    `${isOpenSideMenu ? 200 : 50}px`,
  );

  // ダイアログを開く
  const openAccountDialog = useCallback(() => setAccountDialogOpen(true), []);
  // ダイアログを閉じる
  const closeAccountDialog = useCallback(() => setAccountDialogOpen(false), []);

  // ウィンドウのリサイズに応じてダイアログの位置を更新
  useEffect(() => {
    const updateTop = () => {
      if (typeof window !== "undefined") {
        setDialogTop(`calc(${window.innerHeight}px - 445px)`);
      }
    };
    updateTop();
    window.addEventListener("resize", updateTop);
    return () => window.removeEventListener("resize", updateTop);
  }, []);

  useEffect(() => {
    setDialogLeft(`${isOpenSideMenu ? 200 : 50}px`);
  }, [isOpenSideMenu]);

  return {
    isAccountDialogOpen,
    openAccountDialog,
    closeAccountDialog,
    dialogTop,
    dialogLeft,
  };
};
